import axios from "../../axios";

export default {
    getAllSchedules(data) {
        return axios.get("activations/schedulers", {params: data})
    },
    getAllAudiences(data) {
        return axios.get("activations/schedulers/all-audiences", {params: data})
    },
    createNewSchedule(data) {
        return axios.post("activations/schedulers/create", data)
    },
    updateSchedule(data) {
        return axios.post("activations/schedulers/update", data)
    },
    getSingleScheduler(data) {
        return axios.get('activations/schedulers/single-scheduler', {params: data})
    },
    deleteSchedule(data) {
        return axios.post('activations/schedulers/delete', data)
    },
    activateSchedule(data) {
        return axios.post('activations/schedulers/activate', data)
    },
    deactivateSchedule(data) {
        return axios.post('activations/schedulers/deactivate', data)
    },
}